<template>
  <div v-if="list && list.length">
    <bread-crumb
      :vector="[
        {
          fa: 'فروشگاه ' + supplierName,
          path: '/store/' + route.params.supplier_id,
        },
        {
          fa: 'دسته بندی ' + ordinationName,
          path:
            '/Category/ordinant/' +
            route.params.id +
            '/' +
            $route.params.supplier_id,
        },
      ]"
      v-if="ordinationName && supplierName"
    />
    <div id="scrollTemp">
      <div
        class="d-flex bg-white rounded mx-auto overflow-auto mb-4 mt-2 scroll-example"
        id="scrollTempDiv"
      >
        <button
          class="px-3 my-font py-2 text-dark group-title"
          style="
            min-width: fit-content;
            cursor: pointer;
            border: none;
            background-color: transparent;
          "
          v-for="(item, index) in list"
          :key="index"
          :href="'#group' + item.id"
          :id="'group' + item.id + 'title'"
          @click="goOnPage($event, item.id)"
        >
          <img
            :src="'https://radap.ir/' + item.src"
            width="50"
            v-if="item.src"
          />
          {{ item.name }}
        </button>
      </div>
      <section
        class="sc-o27kl3-0 gsZmuC product-slider-section group-item mb-2"
        v-for="(pitem, index) in list"
        :key="pitem.id"
        :data-group-id="pitem.id"
        :id="'group' + pitem.id"
      >
        <div class="d-flex justify-content-between">
          <h3
            class="mb-1 h3 mr-2 group-name"
            style="
              font-size: 1.2em;
              width: 100%;
              overflow: hidden;
              white-space: pre-line;
            "
          >
            {{ pitem.name }}
          </h3>
        </div>
        <div class="sc-d8w7bo-1 jpdybm">
          <div class="d-flex flex-wrap" style="padding-inline: 3px; gap: 1px">
            <product-border :list="pitem.item" />
          </div>
        </div>
      </section>
    </div>
  </div>
  <Loading v-else page="ordination" />
</template>
<script setup>
import { ref, watch, computed, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import ProductBorder from "../../item/ProductBorder.vue";
import BreadCrumb from "../../../section/item/BreadCrumb.vue";
import Loading from "../../../section/item/loading.vue";
const route = useRoute();
let list = ref([]);
let ordinationName = ref("");
let supplierName = ref("");
const group = computed(() => route.params.id || 1);
let classFlage = ref(false);
watch(
  group,
  async () => {
    await getItems();
  },
  { immediate: true }
);
async function getItems() {
  let response = await fetch(`https://radap.ir/Backend/api/section/pages/group/groups.php?id=${group.value}&supplier_id=${route.params.supplier_id}`);
  let data = await response.json();

  const closeBtn = document.querySelector("#MenuModalCloseBTN");
  closeBtn?.click();
  
  list.value = Object.values(data.items);
  supplierName.value = data.supplier_name;
  ordinationName.value = data.ordination_name;
  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
}
function goOnPage(e, id) {
  if (classFlage.value != false) {
    document.getElementsByClassName("active")[0].classList.remove("active");
  }
  classFlage.value = true;
  e.target.classList.add("active");
  var element = document.getElementById("group" + id);
  var headerOffset = 132;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "auto",
  });
}
// تعریف کردن ایونت اسکرول برای انتخاب گروه های تیتر بصورت پیش فرض
document.addEventListener("scroll", getActiveGroup);
onUnmounted(() => {
  // حذف ایونت اسکرول بعداز بستن صفحه
  document.removeEventListener("scroll", getActiveGroup);
});

function getActiveGroup() {
  let pageScroll = window.scrollY;
  let elemPos;
  let id;
  document.querySelectorAll(".group-item").forEach((elem, index) => {
    elemPos = Math.round(elem.getBoundingClientRect().top) + pageScroll - 140;
    id = elem.id;
    if (pageScroll > elemPos) {
      document.querySelectorAll(".active").forEach((aelem) => {
        aelem.classList.remove("active");
      });
      // console.log(id+'title');
      if (document.getElementById(id + "title")) {
        document.getElementById(id + "title").classList.add("active");
        goOnPage2();
      }
    }
  });
}
function goOnPage2() {
  var element = document.querySelector(".active");
  var offsetPosition = element.offsetLeft - 100;
  document.getElementById("scrollTempDiv").scrollTo({
    left: offsetPosition,
    behavior: "auto",
  });
}
</script>
<style scoped>
.my-opacity {
  opacity: 0.5 !important;
}
.my-font {
  font-size: 16px;
  font-weight: 700;
}
.my-padding {
  padding: 0.75em !important;
}
.active {
  color: red !important;
}
#scrollTempDiv {
  width: 96%;
  border: 1px solid #dee2e6 !important;
  position: sticky;
  top: 49px;
  z-index: 997;
}
</style>
